import { render } from "./SummaryDetailsLabel.vue?vue&type=template&id=3e1674ba&scoped=true"
import script from "./SummaryDetailsLabel.vue?vue&type=script&lang=js"
export * from "./SummaryDetailsLabel.vue?vue&type=script&lang=js"

import "./SummaryDetailsLabel.vue?vue&type=style&index=0&id=3e1674ba&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1674ba"]])

export default __exports__